import { FLOWCHART_COLORS } from '../Cmarkdownflowchart/flowchart-constants';

export const COLUMN_WIDTH = 232;
export const COLUMN_GAP = 10;
export const CARD_GAP = 9;
export const COLUMN_MAX_HEIGHT = 400;

export const COLUMN_COLORS = FLOWCHART_COLORS;

export const KANBAN_PRIORITY = {
  VeryHigh: 'Very High',
  High: 'High',
  Low: 'Low',
  VeryLow: 'Very Low',
} as const;

export type KanbanPriority = (typeof KANBAN_PRIORITY)[keyof typeof KANBAN_PRIORITY];

export const PRIORITY_COLORS: Record<KanbanPriority, string> = {
  [KANBAN_PRIORITY.VeryHigh]: '#FF7EB3',
  [KANBAN_PRIORITY.High]: '#F29F57',
  [KANBAN_PRIORITY.Low]: '#5B9EFF',
  [KANBAN_PRIORITY.VeryLow]: '#94A3B8',
};

export const DIMMED_OPACITY = 0.4;
export const TRANSITION_MS = 150;
